import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { PACKAGES_BASE_QUERY_KEY } from '@/api/packages/get-packages-dashboard'
import { resetQueries } from '@/utils/api'

interface DeletePackageRequest {
  id: number
}

export const archivePackage = async (data: DeletePackageRequest): Promise<void> => {
  await authAPI.delete(`/packages/${data.id}`)
}

export const useArchivePackage = () => {
  return useMutation({
    mutationFn: archivePackage,
    onSuccess: () => {
      resetQueries([PACKAGES_BASE_QUERY_KEY])
    },
  })
}
